export enum TransformationTypes {
  Zscore = 'ZS',
  UDF = 'UF',
  Aggregation = 'AG',
  DropFields = 'DF',
  Join = 'JR',
  Union = 'UN',
  DateSplit = 'DS',
  DropDuplicates = 'DP',
  DropRows = 'DR',
  ForwardFill = 'FF',
  RenameColumn = 'RC',
  Concat = 'CC',
  CaseSet = 'CS',
  ReplaceNulls = 'RN',
  Sort = 'SR',
  DataTypeConversion = 'DC',
  FindAndReplace = 'FR',
  Filter = 'FL',
  Lookup = 'LK',
  Split = 'SP',
  Transpose = 'TP',
  Cumulative = 'CU',
  BoxCox = 'BC',
  ReplaceMapping = 'RM',
  DateToInteger = 'DI',
}
